'use strict'

/* eslint-disable */

// serve with hot reload at localhost:8080
//#npm run dev
// build for production with minification
//#npm run build

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// polyfill all `core-js` features:
import "core-js";
// import 'babel-polyfill'
// import '@babel/polyfill'
// import 'mutationobserver-shim'

import Vue from 'vue'
import '@/plugins/bootstrap-vue'
import '@/plugins/globals'
import App from './App'
import router from './router'
import axios from 'axios'
import { BIconVolumeDown } from "bootstrap-vue";
import constants from "@/config/constants"
import utils from "@/utils/utils"

// console.log(`defined in webpack.[dev,prod].conf.js?`)
console.log(`process.env ${process.env}  __VERSION__  ${__VERSION__}  __BUILD__  ${__BUILD__}` )

// import '@/plugins/bootstrap-vue'

// https://bootstrap-vue.js.org/docs/
// https://developer.okta.com/blog/2018/02/15/build-crud-app-vuejs-node
/// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
/// import 'bootstrap/dist/css/bootstrap.css'
/// import 'bootstrap-vue/dist/bootstrap-vue.css'

/// import { library } from '@fortawesome/fontawesome-svg-core'
/// import { faUserSecret, faKey, faMask, faCat, faAngry, faBell } from '@fortawesome/free-solid-svg-icons'
/// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* eslint-disable no-new */

/// Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
/// Vue.use(IconsPlugin)

Vue.config.productionTip = false

// https://v1.vuejs.org/guide/custom-filter.html
// replace newline with <br>
Vue.filter('nl2br', function (value) {
  // here `input` === `this.userInput`
  return (value) ? value.replace(/\r\n/g,'<br>') : value
})

// Converts seconds to HH:MM:SS
Vue.filter('prettyDate', dt => utils.prettyDate(dt))
Vue.filter('prettyDateTime', dt => utils.prettyDateTime(dt))
Vue.filter('prettySeconds', seconds => utils.prettySeconds(seconds))
Vue.filter('prettyNumber', num => utils.prettyNumber(num))
Vue.filter('prettyCEType', typeId => {
  // Tried to put this into utils.  Turbulence.
  // console.log(`prettyCEType  typeId ${typeId} home ${typeId == constants.CE_TYPEID.HOME_STUDY} live ${constants.CE_TYPEID.PARTICIPATORY}`)
  let aout = 'undefined'
  if (typeId == constants.CE_TYPEID.HOMESTUDY) {
      aout = 'Self-study'
  }
  else if (typeId == constants.CE_TYPEID.PARTICIPATORY) {
      aout = 'Live, Interactive'
  }
  return aout
})

// TBD add to config
// https://github.com/axios/axios
// https://blog.jscrambler.com/build-a-task-management-app-using-vue-js-and-a-node-js-backend/

const hostMap = {
  defaultRunMode: 'prod',
  sites: {
    local: {
      hosts: ['localhost'],
      api: 'http://localhost:3000'
    },
    test: {
      hosts: ['ebook.viva9.us','forms.viva9.us','viva-ebook-test.azurewebsites.net'],
      api: 'https://appapi.vivalearning.viva9.us'
      // api: 'https://vp-mobile-api-test.azurewebsites.net'
    },
    prod: {
      hosts: ['ebook.vivalearning.com','forms.vivalearning.com','viva-ebook.azurewebsites.net'],
      api: 'https://appapi.vivalearning.com'
      // api: 'https://vp-mobile-api.azurewebsites.net'
    }
}}

const RUN_MODE_FORCED = ''  // set to local, test, prod to force backend choice
console.log(Object.keys(hostMap.sites))
let runMode = utils.getRunMode(location.host, hostMap, RUN_MODE_FORCED)

// let runMode = 'prod'
let baseUrl = utils.getApiBaseUrl(runMode, hostMap)
console.log(`runMode: ${runMode}  baseUrl: ${baseUrl}`)
axios.defaults.baseURL = baseUrl
// if (runMode == 'local') {
//   axios.defaults.baseURL = 'http://localhost:3030'
// }
// else if (runMode == 'test') {
//   axios.defaults.baseURL = 'https://vp-mobile-api-test.azurewebsites.net'
// }
// else {  // default production
//   axios.defaults.baseURL = 'https://vp-mobile-api.azurewebsites.net'
// }

// https://github.com/FortAwesome/vue-fontawesome
// add the "solid" icons to the core library
/// library.add(faUserSecret, faKey, faMask, faCat, faAngry, faBell)
/// Vue.component('font-awesome-icon', FontAwesomeIcon)

// Global Data
var data = {
  token: '',  // student token students.hash
  studentId: 0,
  studentHash: '',
  studentName: '',
  studentEmail: '',
  bookId: 0,
  bookHash: '',
  testval: 'TESTVAL',
  version: __VERSION__,
  build: __BUILD__,
}

var vm = new Vue({
  el: '#app',
  data: data,
  router,
  components: { App },
  template: '<App/>',
  methods: {
    getToken() {
      return this.token || localStorage.getItem('id_token') || ''
    },
    setToken(token) {
      this.token = token
      localStorage.setItem('id_token', token)   // used by router(temporarily) and to provide persistence
    },
    getVersion() { return this.version },
    getBuild() { return this.build },
    getStudentHash () { return this.studentHash },
    setStudentHash (hash) { this.studentHash = hash }
  }
})



// WEBPACK FOOTER //
// ./src/main.js